import { useEffect } from "react";

declare global {
	interface Window {
		ttq?: any;
		TiktokAnalyticsObject?: string;
	}
}

/**
 * Initialize the TikTok Pixel only when REACT_APP_TIKTOK_PIXEL_ID is set
 */
const useTikTokPixel = (): void => {
	useEffect(() => {
		const pixelId = process.env.REACT_APP_TIKTOK_PIXEL_ID;

		if (!pixelId) {
			console.log("TikTok Pixel disabled (no ID)");
			return;
		}

		if (window.ttq) {
			window.ttq.page();
			return;
		}

		(function (w: any, d: Document, t: string) {
			w.TiktokAnalyticsObject = t;
			const ttq = (w[t] = w[t] || []);
			ttq.methods = [
				"page",
				"track",
				"identify",
				"instances",
				"debug",
				"on",
				"off",
				"once",
				"ready",
				"alias",
				"group",
				"enableCookie",
				"disableCookie",
				"holdConsent",
				"revokeConsent",
				"grantConsent"
			];
			ttq.setAndDefer = function (target: any, method: string) {
				target[method] = function (...args: any[]) {
					target.push([method].concat(args));
				};
			};
			for (let i = 0; i < ttq.methods.length; i++) {
				ttq.setAndDefer(ttq, ttq.methods[i]);
			}
			ttq.instance = function (target: string) {
				const e = ttq._i[target] || [];
				for (let n = 0; n < ttq.methods.length; n++) {
					ttq.setAndDefer(e, ttq.methods[n]);
				}
				return e;
			};
			ttq.load = function (e: string, n?: any) {
				const r = "https://analytics.tiktok.com/i18n/pixel/events.js";
				ttq._i = ttq._i || {};
				ttq._i[e] = [];
				ttq._i[e]._u = r;
				ttq._t = ttq._t || {};
				ttq._t[e] = +new Date();
				ttq._o = ttq._o || {};
				ttq._o[e] = n || {};
				const script = d.createElement("script");
				script.type = "text/javascript";
				script.async = true;
				script.src = `${r}?sdkid=${e}&lib=${t}`;
				const firstScript = d.getElementsByTagName("script")[0];
				firstScript?.parentNode?.insertBefore(script, firstScript);
			};

			ttq.load(pixelId);
			ttq.page();
		})(window, document, "ttq");

		console.log(`✅ TikTok Pixel initialized: ${pixelId}`);
	}, []);
};

export default useTikTokPixel;
